// extracted by mini-css-extract-plugin
export default {"trend":"style_trend__5OZuV","trend__title":"style_trend__title__IK4FU"};